import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import update from 'immutability-helper';
import { findIndex } from 'lodash';
import { graphqlApi } from './config';
import { onError } from "@apollo/client/link/error";
import { ApolloError } from 'apollo-server-errors';


const cache = new InMemoryCache({
  dataIdFromObject: o => {
    let key = '';
    switch (o.__typename) {

      case '_toupaoOptionField':
        key = `${o.__typename}_${Math.floor(Math.random() * 1000)}`;
        break;
      case 'Profile':
        key = `${o.__typename}_${Math.floor(Math.random() * 1000)}`;
        break;

      case '_nameList':
        key = `${o.no}_${o.name}_${Math.floor(Math.random() * 1000)}`;
        break;
      case '_wifiField':
        key = `${o.ssid}_${o.bssid}_${Math.floor(Math.random() * 1000)}`;
        break;

      case '_locationField':
        key = `${o.longtitude}_${o.latitude}_${Math.floor(Math.random() * 1000)}`;
        break;
      case '_optionField':
        key = `${o.__typename}_${o.title}_${Math.floor(Math.random() * 1000)}`;
        break;
      case '_allowSubmitTimeRules':
        key = `${o.__typename}_${o._id}_${Math.floor(Math.random() * 1000)}`;
        break;
      case '_infoFormField':
        key = `${o.__typename}_${o.order}_${o.title}_${Math.floor(Math.random() * 1000)}`;
        break;
      case '_tpNameList':
        key = `${o.no}_${o.name}_${Math.floor(Math.random() * 1000)}`;
        break;
      case '_showConditions':
        key = `${o.__typename}_${o.optionId}_${o.optionIdxs}_${Math.floor(Math.random() * 1000)}`;
        break;
      default:
        key = `${o.__typename}_${o._id || Math.floor(Math.random() * 1000)}`
    }
    return key;
  },
});

const omitDeepArrayWalk = (arr, key) => {
  return arr.map((val) => {
    if (Array.isArray(val)) return omitDeepArrayWalk(val, key);
    else if (typeof val === 'object') return omitDeep(val, key);
    return val;
  });
};
// 移除__typename
const omitDeep = (obj, key) => {
  const keys = Object.keys(obj);
  const newObj = {};
  keys.forEach(i => {
    if (i !== key) {
      const val = obj[i];
      if (val instanceof Date) newObj[i] = val;
      else if (Array.isArray(val)) newObj[i] = omitDeepArrayWalk(val, key);
      else if (typeof val === 'object' && val !== null)
        newObj[i] = omitDeep(val, key);
      else newObj[i] = val;
    }
  });
  return newObj;
};

const httpLink = createHttpLink({
  uri: graphqlApi,
});
const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

const errorLink = onError(({ graphQLErrors, networkError, response }) => {
  if (graphQLErrors) {
    if (response) {
      response.errors = new ApolloError(graphQLErrors[0])
    } else {
      console.log('response not exist', graphQLErrors)
    }

  }
  // graphQLErrors.map(({ message, locations, path }) =>
  //   
  //     `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
  //   )
  // );
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const clientOptions = {
  link: authLink.concat(errorLink).concat(httpLink),
  // link,
  uri: graphqlApi,
  fetchOptions: {
    credentials: 'include',
  },
  request: async (operation) => {

    const token = await localStorage.getItem('token');
    operation.setContext({
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    if (operation.query && operation.query.definitions && operation.query.definitions.length > 0 && operation.query.definitions[0].operation === 'mutation') {
      if (operation.variables) {
        operation.variables = omitDeep(operation.variables, '__typename')
      }
    }
    // console.log('get operation', operation)
  },
  cache,
  // clientState: {
  //   defaults,
  //   resolvers,
  //   typeDefs
  // }
}

const client = new ApolloClient(clientOptions);
export const readQuery = (variables, query) => {
  const queryParams = {
    variables,
    query,
  }
  const data = client.readQuery(queryParams);
  return data;
}

export const addItemToCache = (variables, query, name, nItem) => {
  const queryParams = {
    variables,
    query,
  }
  try {
    const data = client.readQuery(queryParams);


    const nData = update(data, {
      [name]: {
        $push: [nItem]
      }
    })
    client.writeQuery({
      ...queryParams,
      data: nData
      // data: {
      //   ...data,
      //   [name]: [
      //     ...data[name],
      //     nItem
      //   ]
      // }
    })
    return nData[name]
  } catch (e) {

    return []
  }
}

export const delItemFromCache = (variables, query, name, itemId) => {
  const queryParams = {
    variables,
    query,
  }
  const data = client.readQuery(queryParams);
  // let items = [...data[name]];
  const idx = findIndex(data[name], ['_id', itemId]);

  // if (idx > -1) {

  // }
  // items.splice(idx, 1)
  if (idx > -1) {
    const nData = update(data, {
      [name]: {
        $splice: [[idx, 1]]
      }
    })

    client.writeQuery({
      ...queryParams,
      data: nData
    })
    return nData[name];
  } else {
    return data[name]
  }
}


const AppWithApollo = () => (
  <ApolloProvider client={client}>
    <Router>
      <App />
    </Router>
  </ApolloProvider>
)

ReactDOM.render(<AppWithApollo />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
